import * as React from "react";
import Input from "../../Input-new/Input";
import Checkbox from "../../CheckboxNew";
import Dropdown from "../../Dropdown/Dropdown";

const InNegotiationUnderContract = ({isAgent, data, handleChangeInput, handleChangeDropdown, redirectToEscrowTracking, viewMode, deleted}) => {
    return (
        <div className="In-negotiation">
            {
                data.STATUS === 'Under Contract' &&
                <div className="In-negotiation_actions">
                    <button type='button'
                            className='button-new positive'
                            onClick={redirectToEscrowTracking}>
                        Escrow Tracking
                    </button>
                </div>
            }
            <div className="In-negotiation_column">
                <Checkbox
                    text='HSC Financing'
                    type={viewMode ? 'uncheckable' : 'checkable'}
                    isSelected={data.HSC_FINANCING}
                    handleClick={handleChangeInput}
                    name='HSC_FINANCING'
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="integer"
                    name="NEGOTIATION_PRICE"
                    label="Price"
                    value={data.NEGOTIATION_PRICE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="percent"
                    name="NEGOTIATION_CAP_RATE"
                    label="Cap Rate - auto"
                    value={data.NEGOTIATION_CAP_RATE}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="POTENTIAL_FEE"
                    label="STRIVE Fee - Auto"
                    value={data.POTENTIAL_FEE}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="NEGOTIATION_PRICE_PER_SQFT"
                    label="PSF – auto"
                    value={data.NEGOTIATION_PRICE_PER_SQFT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
            </div>
            {
                data.HSC_FINANCING &&
                <div className="In-negotiation_column">
                    <Dropdown
                        className="In-negotiation_column_item"
                        data={data}
                        isFromProperty
                        optionsType='status-financing'
                        value={data.HSC_STATUS}
                        valueKey="HSC_STATUS"
                        label='Status'
                        disabled={isAgent}
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            }
        </div>
    );
};

export default InNegotiationUnderContract;
